/**
 * Utente AI — governed view over the directory. kind:'party', on the entity-spine.
 * Source: Marko spec §10. coreBOS-A: extension of Users + Entra ID connector.
 *
 * Not a fresh identity store — populated by Entra ID SAML/OAuth2 group import.
 * `utente_id_pseudo` is HMAC(upn, vaultKey) — the pseudonymization bridge to ai_interaction.
 * The HMAC key is held in a separate vault (DPO/IT Security); this field is NOT the key.
 * Highest identifying sensitivity in the system: it is the only path to re-identification.
 *
 * Lifecycle: Attivo → Sospeso → Cessato, driven by directory sync (not a manual BPM approval).
 */
export const aiUserDescriptor = {
    slug: 'ai_user',
    kind: 'party',
    label: { singular: 'Utente AI', plural: 'Utenti AI' },
    table: 'ai_portal_ai_user',
    idStrategy: 'sha256',
    fields: [
        { name: 'nome_upn', type: 'text', label: 'Nome (UPN)', required: true, unique: true },
        { name: 'ruolo', type: 'text', label: 'Ruolo', required: true },
        { name: 'unita_organizzativa', type: 'text', label: 'Unità organizzativa', required: true },
        { name: 'lingua', type: 'text', label: 'Lingua', required: true }, // Italiano | Inglese
        { name: 'centro_di_costo', type: 'text', label: 'Centro di costo' },
        { name: 'stato', type: 'text', label: 'Stato', required: true }, // Attivo | Sospeso | Cessato
        // HMAC(upn, vaultKey) — bridge to ai_interaction.utente_id; auto-set at sync time
        { name: 'utente_id_pseudo', type: 'text', label: 'ID pseudonimizzato' },
    ],
    behaviors: {
        audit: true,
        tenantScoped: true,
    },
    emits: ['ai_user.provisioned', 'ai_user.suspended', 'ai_user.terminated'],
    ui: { mode: 'generated', icon: 'UserOutlined', navGroup: 'Compliance', navOrder: 10 },
};
